import PackageItem from './PackageItem';
import { Package, SearchParams, YadoHotel, YadoRoom } from '../types';

type PackageListProps = {
  hotel: YadoHotel;
  room: YadoRoom;
  packages: Package[];
  localizedAttributes: {
    mainAmenities: Record<string, string | string[]>;
    otherAmenities: Record<string, string>;
  };
  icons: {
    foodIcon: string;
    noFoodIcon: string;
    hotelIcon: string;
    smokingIcon: string;
    noSmokingIcon: string;
    wifiIcon: string;
    yadoIcon: string;
    bedIcon: string;
    onsenIcon: string;
    ticketIcon: string;
    ticketIconSolid: string;
    skiIcon: string;
    commonTicketIcon: string;
    plusIcon: string;
  };
  query: SearchParams;
};

const PackageList: React.FC<PackageListProps> = ({ hotel, room, packages, localizedAttributes, icons, query }) => {
  const gon = (window as any).gon;
  const locale = gon.locale;

  return (
    <>
      {packages.map((packageItem) => {
        return (
          <PackageItem
            key={packageItem.id}
            packageItem={packageItem}
            hotel={hotel}
            currency={packageItem.total_price['currency']}
            localizedItemName={packageItem.snow_item.localized_name}
            room={room}
            localizedAttributes={localizedAttributes}
            icons={icons}
            query={query}
          />
        );
      })}
    </>
  );
};

export default PackageList;
